import { FormattedMessage } from 'react-intl';

import { TextButton } from '@xing-com/button';
import { getTrackingUrl } from '@xing-com/crate-entity-pages-common/src/tracking';
import { JobsBookmark } from '@xing-com/crate-entity-pages-jobs';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { BodyCopy, Meta } from '@xing-com/typography';

import * as Styled from './jobs-header.styles';

const XING_JOBBOX_URL = 'https://www.xing.com/jobs/jobbox';

type JobHeaderProps = {
  boundedTotal: number;
};

export const JobHeader: React.FC<JobHeaderProps> = ({ boundedTotal }) => {
  const { isLoggedIn } = useLoginState();

  return (
    <Styled.Header>
      <Meta noMargin size={'small'}>
        <FormattedMessage
          id={boundedTotal ? 'EP_JOB_ADS_FOUND' : 'EP_SOME_JOB_ADS_FOUND'}
          values={{ total: boundedTotal > 99 ? '99+' : boundedTotal }}
        />
      </Meta>
      {isLoggedIn ? (
        <Styled.JobBoxLink>
          <JobsBookmark initialBookmark fixedValue />
          <TextButton
            href={getTrackingUrl({
              to: XING_JOBBOX_URL,
              trackingKey: 'viewJobOffers',
            })}
            target="_blank"
          >
            <BodyCopy
              fontWeight="bold"
              lineHeight="dense"
              size={'small'}
              noMargin
            >
              <FormattedMessage id="EP_JOB_JOBBOX" />
            </BodyCopy>
          </TextButton>
        </Styled.JobBoxLink>
      ) : null}
    </Styled.Header>
  );
};
